import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectInDisplayContent } from '../../features/displayContent/selectors'
import { VideoSlitLampContent } from '../../model/model'
import {
	FirstLine,
	ImagesBox,
	SecondLine,
	ThirdLine,
	TitleWrapper,
	Wrapper,
} from './CommonComponents'
import MediaBox from './MediaBox'

const isVideoSlitLampContent = (
	content?: any,
): content is VideoSlitLampContent => content?.section === 'videoSlitLamp'

export const VideoSlitLamp: React.FC = () => {
	const { t } = useTranslation()
	const displayContent = useSelector(selectInDisplayContent)

	const data = displayContent?.data
	return (
		<Wrapper>
			<TitleWrapper>
				<FirstLine>{t('content.clinicalData')}</FirstLine>
				<SecondLine>{t('content.videoSlitLamp')}</SecondLine>
				<ThirdLine>{t('content.videoSlitLampInfo')}</ThirdLine>
			</TitleWrapper>
			{isVideoSlitLampContent(data) && (
				<ImagesBox className="vertical">
					<MediaBox media={data.content.OD} />
					<MediaBox media={data.content.OS} />
				</ImagesBox>
			)}
		</Wrapper>
	)
}

export default VideoSlitLamp
